import * as FiIcons from 'react-icons/fi';

export const servicesData = {
  'local-seo': {
    title: "Local SEO Dominance",
    description: "Dominate local search results in Alberta. We specialize in Google Maps optimization and 'near me' rankings.",
    longDesc: "Local SEO is the lifeblood of any home service business. If you aren't in the top 3 of the Google Map Pack, you're losing 70% of potential local leads. We help you own your city.",
    icon: 'FiMapPin',
    features: [
      "Google Business Profile Optimization",
      "Local Citation Audit & Building",
      "Geographic Keyword Targeting",
      "Review Management Strategy",
      "Local Link Building"
    ]
  },
  'aeo': {
    title: "AEO (AI Optimization)",
    description: "Future-proof your Alberta business with Answer Engine Optimization. Get recommended by ChatGPT and Gemini.",
    longDesc: "The way people search is changing. AI engines like Perplexity and ChatGPT are becoming the new 'Yellow Pages'. We ensure your business is the one they recommend.",
    icon: 'FiCpu',
    features: [
      "AI Training Data Optimization",
      "Structured Data & Schema Markup",
      "Conversational Keyword Strategy",
      "Entity-Based SEO Development",
      "LLM Visibility Tracking"
    ]
  },
  'voice-automation': {
    title: "AI Voice & Conversational Automation",
    description: "Capture every lead 24/7 with intelligent AI voice agents and automated missed-call text-back systems.",
    longDesc: "Canadian businesses lose approximately 62% of inbound opportunities simply because nobody answered the phone. Our AI agents ensure your business is never 'closed.'",
    icon: 'FiPhoneCall',
    features: [
      "24/7 Virtual Receptionist",
      "Automated Booking Engine",
      "AI Missed-Call Text-Back",
      "Bilingual Support (English/French)",
      "Lead Qualification Workflows"
    ]
  },
  'crm-system': {
    title: "The CRM: Revenue Command Center",
    description: "Centralize every lead, conversation, and dollar into one intuitive dashboard for total business transparency.",
    longDesc: "Your CRM is the 'Brain' of your operations. We centralize every lead, conversation, and dollar your marketing generates into one intuitive dashboard.",
    icon: 'FiDatabase',
    features: [
      "Unified Smart Inbox",
      "Mobile Office Interface",
      "Reputation Velocity (Auto-Reviews)",
      "Revenue Transparency Reporting",
      "Text-to-Pay Integration"
    ]
  },
  'content-marketing': {
    title: "Authority Content Marketing",
    description: "High-authority content strategies that drive leads. We create expert guides that establish your business as a leader.",
    longDesc: "We don't just write blogs; we build authority. Our content is designed to answer the exact questions your customers are asking, moving them from 'just looking' to 'ready to hire'.",
    icon: 'FiEdit3',
    features: [
      "Topic Cluster Development",
      "Expert-Level Service Guides",
      "User Intent Optimization",
      "Competitive Content Gap Analysis",
      "Conversion-Focused Copywriting"
    ]
  },
  'web-design': {
    title: "High-Converting Web Design",
    description: "Fast, mobile-friendly websites for home service professionals. Optimized for maximum lead generation.",
    longDesc: "A beautiful website is useless if it doesn't convert. We build high-performance sites specifically for Alberta contractors that turn visitors into booked jobs.",
    icon: 'FiLayout',
    features: [
      "Mobile-First Responsive Design",
      "Core Web Vitals Optimization",
      "Conversion Rate Optimization (CRO)",
      "Secure Hosting & Maintenance",
      "Lead Capture Integration"
    ]
  }
};